module.exports = __webpack_public_path__ + "static/media/gecGLogo.1ed6f1a2.png";